export const getAuthToken = () => {
  const authDateRaw = window.localStorage.getItem("AuthDate");
  if (!authDateRaw) return null;

  const { authDate } = JSON.parse(authDateRaw);
  const savedDate = new Date(authDate);
  const diffDays = (new Date() - savedDate) / (1000 * 60 * 60 * 24);
  if (isNaN(diffDays) || diffDays > 3) return null;

  const authTokenRaw = window.localStorage.getItem("AuthToken");
  if (!authTokenRaw) return null;

  return JSON.parse(authTokenRaw).authToken ?? null;
};

export const setAuthToken = (loginCookie) => {
  const data = { authToken: loginCookie }
  try {
    window.localStorage.setItem("AuthToken", JSON.stringify(data));
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const setAuthDate = (authDate) => {
  const data = { authDate: authDate }
  try {
    window.localStorage.setItem("AuthDate", JSON.stringify(data));
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};


export const removeLoginDetails = () => {
  window.localStorage.removeItem("AuthToken");
  window.localStorage.removeItem("AuthDate");
  window.localStorage.removeItem("Username");
  window.localStorage.removeItem("ViewedNotification");
  window.sessionStorage.removeItem("IsLoggedIn");

}

export const getIsLoggedIn = () => {
  if (window.localStorage.getItem("AuthToken") !== null && window.localStorage.getItem("AuthToken") !== undefined)
    return true;
  else
    return false;
}

export const setIsLoggedIn = (value) => {
  try {
    window.sessionStorage.setItem("IsLoggedIn", value);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const getFullname = () => {
  if (window.localStorage.getItem("Username") !== null || (window.localStorage.getItem("Username") !== undefined))
    return window.localStorage.getItem("Username");
  else
    return null;
};

export const setFullname = (props) => {
  try {
    window.localStorage.setItem("Username", props);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getSupplierName = () => {
  if (window.localStorage.getItem("SupplierName") !== null || (window.localStorage.getItem("SupplierName") !== undefined))
    return window.localStorage.getItem("SupplierName");
  else
    return "N/A";
};

export const setSupplierName = (props) => {
  try {
    window.localStorage.setItem("SupplierName", props);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getViewedNotification = () => {
  if (window.localStorage.getItem("ViewedNotification") !== null || (window.localStorage.getItem("ViewedNotification") !== undefined))
    return window.localStorage.getItem("ViewedNotification");
  else
    return false;
};

export const setViewedNotification = (props) => {
  try {
    window.localStorage.setItem("ViewedNotification", props);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};